export const isQuotaExceededError = (e: Error): boolean => {
    return e.message?.toLowerCase().includes('quota');
};
